// on non-web this route has no meaning, but expo requires it since we have a *.web.tsx route for the same name
import { TabPath } from "@/constants/Navigation";
import { Redirect } from "@/crossPlatform/expo-router";
import { toAbsoluteTabPath } from "@/utils/navigation.util";

const MyEquipFallback = () => (
  <Redirect href={toAbsoluteTabPath(TabPath.Home)} />
);

export default MyEquipFallback;
